var map = {
	"./1-theme.png": 4226,
	"./1.png": 7938,
	"./2-theme.png": 5121,
	"./2.png": 1945,
	"./3-theme.png": 4328,
	"./3.png": 6192,
	"./4-theme.png": 6535,
	"./4.png": 8415,
	"./5-theme.png": 5902,
	"./5.png": 3318,
	"./6-theme.png": 477,
	"./6.png": 7085,
	"./7-theme.png": 7620,
	"./7.png": 5956,
	"./8-theme.png": 5491,
	"./8.png": 1251,
	"./Contact.jpg": 6279,
	"./Moonstone.webp": 7946,
	"./qr.jpg": 510,
	"./we-chat.png": 1776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9067;